import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/compCommon/EFPicture';
import EfLink from '@elem/ui/ef-link';
import EVPile from './icons/EVPile';
import Gas from './icons/Gas';
import Grid from './icons/Grid';
import MultiCharge from './icons/MultiCharge';
import Solar from './icons/Solar';
import css from './index.module.scss';

let scene: any = null,
    sceneTextEnterJ: any = null,
    sceneTextLeaveJ: any = null;
export default function SectionA8() {
    const { useLang, useRouter, useEffect, useState } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [hover, setHover] = useState(-1);
    const [textEnter, setTextEnter] = useState(false);
    const isEU = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);

    const icons: any[] = [
        {
            icon: <Grid />,
            text: t('secJ_icon1'),
            note: t('secJ_icon1_hover'),
        },
        {
            icon: <Solar />,
            text: t('secJ_icon2'),
            note: t('secJ_icon2_hover'),
        },
        {
            icon: <Gas />,
            text: t('secJ_icon3'),
            note: t.rich('secJ_icon3_hover', {
                a: (tx: string) => <EfLink href={String(tx)}>{tx}</EfLink>,
            }),
        },
        {
            icon: <EVPile />,
            text: t('secJ_icon4'),
            note: t('secJ_icon4_hover'),
        },

        {
            icon: <MultiCharge />,
            text: t('secJ_icon5'),
            note: t('secJ_icon5_hover'),
        },
    ];

    const handleMouseEnter = (k: number) => {
        if (window?.innerWidth > 1024) {
            setHover(k);
        }
    };

    const handleMouseLeave = () => {
        if (window?.innerWidth > 1024) {
            setHover(-1);
        }
    };

    const handleClick = (e: any, k: number) => {
        console.log('click k', k);
        e.stopPropagation();
        if (window?.innerWidth <= 1024) {
            setHover(k);
        }
    };

    const handleClickOutside = () => {
        console.log('outside');
        if (window?.innerWidth <= 1024) {
            setHover(-1);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterJ) {
                    AniContainer.removeScene(sceneTextEnterJ);
                    sceneTextEnterJ = null;
                }
                if (sceneTextLeaveJ) {
                    AniContainer.removeScene(sceneTextLeaveJ);
                    sceneTextLeaveJ = null;
                }

                const clientH = (window.innerHeight || 0) * 0.6;
                const startH = Math.min(clientH, 600);
                //const textTarget = document.querySelector('.sectionA8 .text-info') as HTMLElement;
                //if (textTarget) {
                sceneTextEnterJ = AniContainer.create({
                    triggerElement: '.sectionA8 .sticky-box',
                    triggerHook: 1,
                    offset: startH, //isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                    duration: 500, //window.innerHeight - isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
                // sceneTextLeaveJ = AniContainer.create({
                //     triggerElement: '.sectionA8 .text-info',
                //     triggerHook: 1,
                //     offset: 0,
                //     duration: window.innerHeight * 3.5,
                //     onLeave: () => setTextEnter(false),
                // });
                //}
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterJ) {
                    AniContainer.removeScene(sceneTextEnterJ);
                    sceneTextEnterJ = null;
                }
                if (sceneTextLeaveJ) {
                    AniContainer.removeScene(sceneTextLeaveJ);
                    sceneTextLeaveJ = null;
                }

                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined' && locale !== 'jp') {
            const resizeAni = () => {
                if (scene) AniContainer.removeScene(scene);
                scene = isEU
                    ? null
                    : AniContainer.create({
                          asyncFromTo: [
                              ['.sectionA8 .img1', { opacity: 1 }, { opacity: 0 }, 0.25],
                              ['.sectionA8 .img2', { opacity: 0 }, { opacity: 1 }, 0.25],
                          ],
                          asyncTimeLine: [1, 1],
                          triggerElement: '.sectionA8',
                          triggerHook: 1,
                          offset: '50%',
                          duration: '150%',
                      });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (scene) AniContainer.removeScene(scene);
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`sectionA8 dpu-detail-section ${css['sectionA8']}`} onClick={handleClickOutside}>
            <div className="sticky-box">
                <div className="imgs">
                    <div className="img-box img1">
                        <EFPicture
                            src={'/responsive/picture/delta-pro-ultra/launch/10_1.jpg'}
                            srcPad={'/responsive/picture/delta-pro-ultra/launch/10_1_768.jpg'}
                            srcMobile={'/responsive/picture/delta-pro-ultra/launch/10_1_768.jpg'}
                            alt={t('secJ_title')}
                        />
                    </div>
                </div>
                <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                    <p className="subtitle">{t('secJ_subtitle')}</p>
                    <h2 className="title">{t('secJ_title')}</h2>
                    <p className="desc">{t('secJ_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any, k: number) => (
                            <li className={`icon ${icon?.note ? 'note' : ''}`} key={k}>
                                <span className="icon-svg">{icon?.icon}</span>
                                <div className="icon-text">
                                    <p className="i-t">{icon?.text}</p>
                                    {icon?.note && (
                                        <div
                                            className="icon-q"
                                            onMouseEnter={() => handleMouseEnter(k)}
                                            onMouseLeave={handleMouseLeave}
                                            onClick={(e: any) => handleClick(e, k)}
                                        >
                                            <svg
                                                className="icon-question"
                                                width="18"
                                                height="18"
                                                viewBox="0 0 18 18"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <circle cx="9" cy="9" r="9" fill="#2E2E2E" />
                                                <path
                                                    d="M8.34 11.096C7.968 9.104 10.8 8.564 10.8 7.196C10.8 6.368 10.2 5.768 8.976 5.768C8.16 5.768 7.38 6.128 6.708 6.86L6.06 6.26C6.852 5.42 7.788 4.868 9.096 4.868C10.788 4.868 11.868 5.732 11.868 7.112C11.868 8.924 9 9.296 9.324 11.096H8.34ZM7.884 13.112C7.884 12.536 8.328 12.176 8.856 12.176C9.384 12.176 9.816 12.536 9.816 13.112C9.816 13.688 9.384 14.06 8.856 14.06C8.328 14.06 7.884 13.688 7.884 13.112Z"
                                                    fill="white"
                                                />
                                            </svg>
                                            {hover === k && <span className="icon-note">{icon?.note}</span>}
                                        </div>
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
